<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/warehouse/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('cangkubianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cangkumingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cangkuleixing')">
            <yi_dictionary_select :max="1" type="WAREHOUSE_TYPE" :ids.sync="yt.conditions.type"></yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'code asc' })">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_base_warehouse_model_create')" size="mini" @click="
      yt.showEditDialog('xinzeng', null, 'w1');
    setDefaultValue();
    " type="primary">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_base_warehouse_model_batch_import')" size="mini" @click="show = !show" plain>
          {{ $t('daoru') }}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('dayin', null, 'w1')" type="primary">
          {{ $t('dayin') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button :loading="warehouse_export_loading" size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_base_warehouse_model_area')" type="text" @click="yt.showEditDialog('kuqu', scope.row, 'w2')">{{ $t('kuqu') }}</el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/basic/warehouse/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('cangkubianma')" required>
            <el-input v-model.trim="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cangkumingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cangkuleixing')" required>
            <yi_dictionary_select :max="1" type="WAREHOUSE_TYPE" :ids.sync="yt.editObj.type"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('dizhi')">
            <el-input v-model="yt.editObj.address"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/basic/warehouse/create')" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 编辑 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('cangkubianma')" required>
            <el-input disabled v-model.trim="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cangkumingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cangkuleixing')" required>
            <yi_dictionary_select :max="1" type="WAREHOUSE_TYPE" :ids.sync="yt.editObj.type"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('dizhi')">
            <el-input v-model="yt.editObj.address"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/basic/warehouse/update')" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 库区 -->
      <template v-if="yt.editObj.action == 'kuqu'">
        <div class="dialog-scroller">
          <reservoir_area :warehouse="yt.editObj"></reservoir_area>
        </div>
      </template>
      <!-- 打印 -->
      <template v-if="yt.editObj.action == 'dayin'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yewuleixing')" required>
            <yi_dictionary_select :max="1" :type="'PRINT_WARE_HOUSE_TAG_TYPE'" :ids.sync="printInfo.businessType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item v-if="printInfo.businessType == 1" :label="$t('xuanzecangku')" required>
            <yi_data_select :key="'0'" :multiple="true" :checkStrictly="false" :warehouseLevel="0" :type="'warehouse'" :ids.sync="printInfo.warehouseIds"> </yi_data_select>
          </el-form-item>
          <el-form-item v-if="printInfo.businessType == 2" :label="$t('xuanzekuqu')" required>
            <yi_data_select :key="'1'" :multiple="true" :checkStrictly="false" :warehouseLevel="1" :type="'warehouse'" :ids.sync="printInfo.warehouseAreaIds"> </yi_data_select>
          </el-form-item>
          <el-form-item v-if="printInfo.businessType == 3" :label="$t('xuanzekuwei')" required>
            <yi_data_select :key="'2'" :multiple="true" :checkStrictly="false" :warehouseLevel="2" :type="'warehouse'" :ids.sync="printInfo.warehouseLocationIds"> </yi_data_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="preview()" type="primary">
            {{ $t('yulan') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog :show-close="true" :title="$t('yulan')" :visible.sync="isShowYulanDialog" :width="'80%'" :close-on-click-modal="false" append-to-body :destroy-on-close="true">
      <div class="dialog-scroller">
        <div style="display: flex;flex-flow: wrap;" id="warehouseModelListPrint">


          <div :id="'printContent_' + id" style="margin-bottom: 18px;" v-for="(id, index) in printInfo.warehouseIds" v-if="printInfo.businessType == 1 && makeWarehouseTitle(id)">
            <div style="text-align: center;">
              <vue-qr :text="printInfo.businessType - 1 + '_' + (id + '').slice(1)" :margin="10" :size="180"></vue-qr>
              <div style="font-size:18px;color:black">{{ makeWarehouseTitle(id) }}</div>
            </div>
          </div>
          <div :id="'printContent_' + id" v-for="(id, index) in printInfo.warehouseAreaIds" v-if="printInfo.businessType == 2 && makeWarehouseTitle(id)">
            <div style="text-align: center;">
              <vue-qr :text="printInfo.businessType - 1 + '_' + (id + '').slice(1)" :margin="10" :size="180"></vue-qr>
              <div style="font-size:18px;color:black">{{ makeWarehouseTitle(id) }}</div>
            </div>
          </div>
          <div :id="'printContent_' + id" v-for="(id, index) in printInfo.warehouseLocationIds" v-if="printInfo.businessType == 3 && makeWarehouseTitle(id)">
            <div style="text-align: center;">
              <vue-qr :text="printInfo.businessType - 1 + '_' + (id + '').slice(1)" :margin="10" :size="180"></vue-qr>
              <div style="font-size:18px;color:black">{{ makeWarehouseTitle(id) }}</div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowYulanDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button v-if="utils.checkPower('web_base_warehouse_model_print_together')" size="mini" @click="print()" type="primary">
          {{ $t('dayin') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_base_warehouse_model_print_separately')" :loading="printLoading" size="mini" @click="printWE()" type="primary">
          {{ $t('dayin') }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 导入excel -->
    <importExcel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
import html2canvas from 'html2canvas';
import print from 'print-js';
import VueQr from 'vue-qr';
import reservoir_area from '@@/pages/web/base/warehouse_model/reservoir_area';
import importExcel from '@@/pages/web/base/warehouse_model/import_excel';
import jsPDF from 'jspdf';
export default {
  name: 'web_base_warehouse_model_list',
  components: {
    VueQr,
    importExcel,
    reservoir_area
  },
  data() {
    return {
      printSN: [],
      blobs: [],
      printLoading: false,
      warehouse_export_loading: false,
      printInfo: {},
      isShowYulanDialog: false,
      show: false,
      columns: [
        {
          label: 'cangkubianma',
          prop: 'code',
          width: 130
        },
        {
          label: 'cangkumingcheng',
          prop: 'name'
        },
        {
          label: 'cangkuleixing',
          prop: 'type',
          type: 'dictionary',
          key: 'WAREHOUSE_TYPE'
        },
        {
          label: 'dizhi',
          prop: 'address'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 150
          // format: "YYYY-MM-DD"
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 230,
          fixed: 'right'
        }
      ]
    };
  },
  computed: {
    makeWarehouseTitle() {
      return id => {
        let title = [];
        if (this.printInfo.businessType == 1) {
          for (let i = 0; i < this.store.state.warehouses.length; i++) {
            let warehouse = this.store.state.warehouses[i];
            if (warehouse.id == id) {
              title[0] = warehouse.code;
              break;
            }
          }

          if (title.length != 1) {
            return false; //false代表选了类型不对的，因为选择库位的时候，空仓库也是可选的
          }
        } else if (this.printInfo.businessType == 2) {
          A: for (let i = 0; i < this.store.state.warehouses.length; i++) {
            let warehouse = this.store.state.warehouses[i];
            title[0] = warehouse.code;

            if (warehouse.children) {
              for (let j = 0; j < warehouse.children.length; j++) {
                if (warehouse.children[j].id == id) {
                  title[1] = warehouse.children[j].code;
                  break A;
                }
              }
            }
          }
          if (title.length != 2) {
            return false; //false代表选了类型不对的，因为选择库位的时候，空仓库也是可选的
          }
        } else if (this.printInfo.businessType == 3) {
          A: for (let i = 0; i < this.store.state.warehouses.length; i++) {
            let warehouse = this.store.state.warehouses[i];
            title[0] = warehouse.code;
            if (warehouse.children) {
              for (let j = 0; j < warehouse.children.length; j++) {
                title[1] = warehouse.children[j].code;

                if (warehouse.children[j].children) {
                  for (let k = 0; k < warehouse.children[j].children.length; k++) {
                    if (warehouse.children[j].children[k].id == id) {
                      title[2] = warehouse.children[j].children[k].code;
                      break A;
                    }
                  }
                }
              }
            }
          }
          if (title.length != 3) {
            return false; //false代表选了类型不对的，因为选择库位的时候，空仓库也是可选的
          }
        }

        return title.join('-');
      };
    }
  },

  created() {
    setTimeout(() => {
      this.yt.SELECT_URL = '/web/basic/warehouse/getWarehouseByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'name';
      this.yt.conditions = {
        orderBy: 'code asc'
      };
      this.utils.event_hub.$on('WAREHOUSE_LIST_REFRESH', () => {
        this.yt.get(1);
      });
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 预览按钮
    preview() {
      if (!this.printInfo.businessType) {
        return this.$message.warning(this.$t('qingxuanzeyewuleixing'));
      }
      switch (this.printInfo.businessType) {
        case '1':
          if (!this.printInfo.warehouseIds || this.printInfo.warehouseIds.length === 0) {
            return this.$message.warning(this.$t('qingxuanzecangku'));
          }
          break;
        case '2':
          if (!this.printInfo.warehouseAreaIds || this.printInfo.warehouseAreaIds.length === 0) {
            return this.$message.warning(this.$t('qingxuanzekuqu'));
          }
          break;
        case '3':
          if (!this.printInfo.warehouseLocationIds || this.printInfo.warehouseLocationIds.length === 0) {
            return this.$message.warning(this.$t('qingxuanzekuwei'));
          }
          break;
      }
      this.isShowYulanDialog = true;
      this.printConfig = this.utils.copy(this.yt.editObj);
    },
    print() {
      html2canvas(document.getElementById('warehouseModelListPrint')).then(async canvas => {
        const imgData = canvas.toDataURL('image/png');
        print({
          printable: imgData,
          type: 'image',
          documentTitle: '',
          modalMessage: this.$t('zhengzaijiazaiwenjian,qingshaohou')
          // footer: "My Footer Text"
        });
        // 新增打印记录
        let params = {
          businessType: this.printInfo.businessType,
          areaIdList: []
        };

        if (this.printInfo.businessType == '1') {
          params.areaIdList = this.printInfo.warehouseIds;
        } else if (this.printInfo.businessType == '2') {
          params.areaIdList = this.printInfo.warehouseAreaIds;
        } else if (this.printInfo.businessType == '3') {
          params.areaIdList = this.printInfo.warehouseLocationIds;
        }

        params.areaIdList = params.areaIdList.map(item => {
          return (item + '').slice(1);
        });

        const res = await this.http.post('/web/print/record/createPrintRecord', params);
        if (res.code === 200) {
          this.isShowYulanDialog = false;
        }
      });
    },
    printWE() {
      this.blobs = [];

      if (this.printInfo.businessType == 1) {
        this.printSN = this.printInfo.warehouseIds
      }
      else if (this.printInfo.businessType == 2) {
        this.printSN = this.printInfo.warehouseAreaIds
      }
      else if (this.printInfo.businessType == 3) {
        this.printSN = this.printInfo.warehouseLocationIds
      }
      this.printLoading = true;

      this.printSN = this.printSN.filter(id => {
        return this.makeWarehouseTitle(id)
      })
      for (let index = 0; index < this.printSN.length; index++) {
        this.domToPdfBase64('printContent_' + this.printSN[index]);
      }
    },
    domToPdfBase64(targetId) {
      html2canvas(document.getElementById(targetId), {
        scale: 3, // 缩放比例为2，将图像放大一倍
      }).then(canvas => {
        var imgWidth = canvas.width;
        var imgHeight = canvas.height;
        console.log(imgWidth, imgHeight)
        var pageData = canvas.toDataURL('image/jpeg', 1.0);
        //第一个参数： l：横向  p：纵向;第二个参数：测量单位（"pt"，"mm", "cm", "m", "in" or "px"）;第三个参数：可以是下面格式，默认为“a4”
        var pdf = new jsPDF('h', 'px', [imgWidth, imgHeight]);
        console.log(imgWidth, imgHeight)
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        let pdf64 = pdf.output('blob');
        this.blobs.push(pdf64);
        if (this.blobs.length == this.printSN.length) {
          this.sends();
        }

      });
    },
    sends() {
      const formData = new FormData();
      for (let index = 0; index < this.blobs.length; index++) {
        formData.append('files[]', this.blobs[index]);
        formData.append('isVertical', 'true');//不需要旋转图片
      }
      this.http.post('http://127.0.0.1:9090/printLocalPDF', formData, {
        headers: {
          'Content-Type': 'multipart/form-data' // 设置请求头，确保服务器正确解析 FormData
        }
      }).then(res => {
        this.$message.success(this.$t('chenggong'));
        this.isShowYulanDialog = false;
        this.yt.isShowEditDialog = false;

      }).finally(() => {
        this.printLoading = false;

      });
    },
    setDefaultValue() {
      // this.yt.editObj.status = 1;
    },

    exportExcel() {
      let params = this.yt.conditions;
      this.warehouse_export_loading = true;
      return this.http
        .get('/web/report/export/warehouse_model_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.warehouse_export_loading = false;
        });
    }
  }
};
</script>
